interface EnvConfig {
  VITE_AUTH_API_URL?: string;
  VITE_FINAPI_API_URL?: string;
}

const browserEnv = (window as any)._env_ as EnvConfig || {};

export const env = {
  // Prioridade 1: Kubernetes (window._env_)
  // Prioridade 2: Local/Build (.env ou import.meta.env)
  // Prioridade 3: Fallback (URL de segurança)
  AUTH_API_URL: browserEnv.VITE_AUTH_API_URL || import.meta.env.VITE_AUTH_API_URL || 'http://localhost:5000',
  FINAPI_API_URL: browserEnv.VITE_FINAPI_API_URL || import.meta.env.VITE_FINAPI_API_URL || 'http://localhost:5001',
};